module.exports = __webpack_public_path__ + "media/images/header__background__bottomRight-743b0bf302b339a09c6f70355e06b342.png";